<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type Maze from "./maze";

  export let maze: Maze;
  export let grid: boolean = false;

  const dispatch = createEventDispatcher();
</script>

<div class="maze shadow my-2" style="--columns: {maze.width()}">
  {#each maze.grid as row, y}
    {#each row as cell, x}
      <div
        class="cell"
        class:cell-border={grid}
        class:empty={(cell & 3) == 0}
        class:wall={(cell & 3) == 1}
        class:robot={(cell & 3) == 2}
        class:target={(cell & 3) == 3}
        class:unique={maze.isUnique(x, y)}
        on:click={() => dispatch("cell", { x, y })}
        on:mousemove={(e) => {
          if (e.buttons == 1) dispatch("cell", { x, y });
        }}
      >
        <div>
          {#if cell & 4}
            1
          {/if}
          {#if cell & 8}
            2
          {/if}
        </div>
      </div>
    {/each}
  {/each}
</div>

<style>
  .maze {
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    user-select: none;
    max-width: 696px;
    margin: 0 auto;
  }

  .cell {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    text-align: center;
    aspect-ratio: 1;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: clip;
    overflow: hidden;
  }

  .cell-border {
    border: 1px solid gray;
  }

  .wall {
    background-color: gray;
  }

  .robot {
    background-color: red;
  }

  .target {
    background-color: yellowgreen;
  }

  .unique {
    position: relative;
  }

  .unique::after {
    position: absolute;
    top: 0px;
    right: 0px;
    border: 2px solid black;
    content: "";
    z-index: 10;
  }
</style>
